import React, { useEffect } from "react";

import { CircularProgress, Box, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router";

import { AUTH } from "src/platform/constants/routes";

/**
 * OIDC callback error landing page.
 *
 * When the API's `/api/v1/auth/oidc/callback` fails (expired transaction,
 * token exchange failure, email not verified, account exists, etc.), it
 * redirects here with an `oidc_error` query parameter. This component reads
 * the error code and redirects to the login or register page so the user
 * sees a human-readable error message.
 */
const OidcCallbackError: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const errorCode = searchParams.get("oidc_error");
    const target = AUTH.LOGIN.path;
    const params = new URLSearchParams();
    if (errorCode) {
      params.set("oidc_error", errorCode);
    }
    const query = params.toString();
    void navigate(`${target}${query ? `?${query}` : ""}`, { replace: true });
  }, [navigate, searchParams]);

  return (
    <Box
      component="main"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={40} aria-label="Redirecting" />
      <Typography variant="h6" component="h1" sx={{ mt: 2 }}>
        Redirecting...
      </Typography>
    </Box>
  );
};

export default OidcCallbackError;
